































import { TenantModel } from '@/libs/Api';
import { tenantsStore, tenantUsersStore } from '@/libs/tenants/+state/store';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator';

@Component({ })
export default class TenantSelect extends Vue {

    @VModel() innerValue!: string;
    @Prop() placeholder!: string;
    @Prop() readonly!: boolean;
    @Prop() rules!: [ any[] ];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) clearable!: boolean;
    @Prop({ default: false }) mobile!: boolean;

    @Watch("innerValue")
    innerValueChanged (v: string) {
        this.$emit("change", v);
    }

    get items() : Array<TenantModel> {
        return tenantsStore.useGetter(CrudGetter.Data);
    }

}
